// @flow
import types from './checkoutConstants';
import { shareInFlight } from './checkoutRequestDedupe';
import { orderFailurePayload } from './checkoutOrderFailure';
import { getAsync, putAsync, postAsync, deleteAsync, upload } from '../../../_metronic/helpers/httpClient';

/** How long a mount-time cart summary is shared with the next mount (header badge → lazy page). */
export const MOUNT_SUMMARY_REUSE_MS = 2000;

export const clearState = () => async dispatch => {
    dispatch({
        type: types.CLEAR_STATE
    })
}

export const getForm = () => async dispatch => {

    dispatch({
        type: types.GET_FORM
    })

    const response = await getAsync(`/checkout`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_FORM_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_FORM_FAILED,
            payload: response,
        })
    }
}

export const getCart = () => async dispatch => {

    dispatch({
        type: types.GET_CART
    })

    const response = await getAsync(`/carts`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_CART_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_CART_FAILED,
            payload: response,
        })
    }
}

export const postCart = (stringModel) => async dispatch => {

    dispatch({
        type: types.POST_CART
    })

    const response = await postAsync(`/carts`, { data: stringModel });


    if (response.isSuccess) {
        dispatch(getCart())
        dispatch(getCartSummary())
        dispatch({
            type: types.POST_CART_SUCCESS,
            payload: JSON.parse(response.data.data),
        })
    } else {
        dispatch({
            type: types.POST_CART_FAILED,
            payload: response,
        })
    }

    return response;
}

export const putCart = (request) => async dispatch => {

    dispatch({
        type: types.PUT_CART
    })

    const response = await putAsync(`/carts`, request);

    if (response.isSuccess) {
        dispatch({
            type: types.PUT_CART_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.PUT_CART_FAILED,
            payload: response,
        })
    }
}

export const postCalculateCart = (stringModel) => async dispatch => {

    dispatch({
        type: types.POST_CART
    })

    const response = await postAsync(`/carts/calculate`, { data: stringModel });


    if (response.isSuccess) {
        dispatch({
            type: types.POST_CART_SUCCESS,
            payload: JSON.parse(response.data.data),
        })
    } else {
        dispatch({
            type: types.POST_CART_FAILED,
            payload: response,
        })
    }

    return response;
}

// `initial` marks the fetch a component makes on mount (header badge, summary
// page): those may reuse a summary that settled a moment ago, since the lazy
// page chunk mounts just after the header's request answered (ADR-0022). A
// refresh after a cart change never passes it and always hits the API.
export const getCartSummary = (initial = false) => async dispatch => {

    dispatch({
        type: types.GET_CART_SUMMARY
    })

    // Header badge + summary page mount together: share one request.
    const response = await shareInFlight('carts/summary', () => getAsync(`/carts/summary`),
        initial ? { reuseMs: MOUNT_SUMMARY_REUSE_MS } : undefined);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_CART_SUMMARY_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_CART_SUMMARY_FAILED,
            payload: response,
        })
    }
}

export const deleteItem = (uuid) => async dispatch => {

    dispatch({
        type: types.DELETE_CART_ITEM
    })

    const response = await deleteAsync(`/carts/${uuid}`);

    if (response.isSuccess) {
        dispatch(getCart())
        dispatch(getCartSummary())
        dispatch({
            type: types.DELETE_CART_ITEM_SUCCESS,
            payload: response.data,
        })
    } else {
        dispatch({
            type: types.DELETE_CART_ITEM_FAILED,
            payload: response,
        })
    }

    return response;
}

export const deleteCart = () => async dispatch => {

    dispatch({
        type: types.DELETE_CART
    })

    const response = await deleteAsync(`/carts`);

    if (response.isSuccess) {
        dispatch({
            type: types.DELETE_CART_SUCCESS,
            payload: response.data,
        })
    } else {
        dispatch({
            type: types.DELETE_CART_FAILED,
            payload: response,
        })
    }

    return response;
}

export const uploadFile = (file) => async dispatch => {

    var request = {
        fileName: file.name,
        fileExtension: file.extension,
        actionType: file.actionType
    };

    const response = await postAsync(`/signed-url/upload`, request);

    var data = {
        id: file.id,
        file: file.file
    }

    if (response.isSuccess) {
        await upload(response.data.url, data);
        return response;
    }

    return response;
}

export const postOrder = (cart) => async dispatch => {
    dispatch({
        type: types.POST_ORDER
    })

    // No toast here: the summary page shows the failure (which catalog
    // product/variant was missing) in a dialog the user can actually read.
    const response = await postAsync(`/orders`, cart, false);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_ORDER_SUCCESS,
            payload: response.data,
        })
    } else {
        dispatch({
            type: types.POST_ORDER_FAILED,
            payload: orderFailurePayload(response),
        })
    }
}



/**
 * One cart line reconfigured in place (ADR-0040): the veranda's "Edit
 * configuration" sends the whole line under the uuid it has. The cart and
 * its summary are read again afterwards; the cut-list page re-syncs the draft.
 */
export const putCartItem = (uuid, stringModel) => async dispatch => {
    dispatch({
        type: types.PUT_CART_ITEM
    })

    const response = await putAsync(`/carts/${uuid}`, { data: stringModel });

    if (response.isSuccess) {
        dispatch(getCart())
        dispatch(getCartSummary())
        dispatch({
            type: types.PUT_CART_ITEM_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.PUT_CART_ITEM_FAILED,
            payload: orderFailurePayload(response),
        })
    }
    return response;
}

/**
 * Brings the hidden draft order in line with the cart (ADR-0040): creates it
 * on the first visit to the cut list, re-syncs it line by line afterwards.
 * The answer names the cart lines that were rebuilt and the ones whose edits
 * survived; the cut-list page reads the draft's rows by the order id.
 */
export const syncDraftOrder = () => async dispatch => {
    dispatch({
        type: types.SYNC_DRAFT
    })

    const response = await postAsync(`/orders`, { draft: true }, false);

    if (response.isSuccess) {
        dispatch({
            type: types.SYNC_DRAFT_SUCCESS,
            payload: response.data,
        })
    } else {
        dispatch({
            type: types.SYNC_DRAFT_FAILED,
            payload: orderFailurePayload(response),
        })
    }
    return response;
}

export const thanksPage = (id) => async dispatch => {

    dispatch({
        type: types.GET_THANKS_PAGE
    })

    const response = await getAsync(`/thanks-page/${id}`, false);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_THANKS_PAGE_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_THANKS_PAGE_FAILED,
            payload: response,
        })
    }
}

export const getCheckoutPay = (boid) => async dispatch => {
    dispatch({
        type: types.GET_CHECKOUT_PAY
    })

    var path = `/checkout/pay`;
    if (boid)
        path += `?boid=${boid}`

    const response = await getAsync(path);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_CHECKOUT_PAY_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_CHECKOUT_PAY_FAILED,
            payload: response,
        })
    }
}

export const postCheckoutPay = (paymentMethod) => async dispatch => {

    dispatch({
        type: types.POST_CHECKOUT_PAY
    })

    const response = await postAsync(`/checkout/pay?paymentMethod=${paymentMethod}`);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_CHECKOUT_PAY_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.POST_CHECKOUT_PAY_FAILED,
            payload: response,
        })
    }
}

/**
 * One leg's parts as the veranda calculator lists them (ADR-0060): the rows a
 * standard veranda of that size is cut from, each with its cut length. Nothing
 * is stored; the caller merges the legs. Quiet: a leg the catalogue cannot cut
 * is named on the Custom tab instead of in a toast.
 */
export const calculateVerandaParts = (request) => postAsync(`/orders/calculate-veranda`, request, false);
